export default "__VITE_ASSET__BuLYWI80__"